import { render, staticRenderFns } from "./bind-phone.vue?vue&type=template&id=59238e72&scoped=true&"
import script from "./bind-phone.vue?vue&type=script&lang=js&"
export * from "./bind-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59238e72",
  null
  
)

export default component.exports